import {useMutation, useQuery} from '@apollo/client';
import {useEffect, useMemo} from 'react';
import {
  OneviewGroups,
  OneviewGroups_oneviewGroups_activitySubGroups,
} from '../../schema-types/OneviewGroups';
import {GET_ACTIVITY_GROUPS, PULL_ACT_GROUP} from './tasksQueries';
import {PullActGroup} from '../../schema-types/PullActGroup';

const subActivityGroupFilter = (x: OneviewGroups_oneviewGroups_activitySubGroups) =>
  x.name !== 'New review created';

export default function useTasks() {
  const [pullActGroup] = useMutation<PullActGroup>(PULL_ACT_GROUP);

  const {
    loading: activityGroupsLoading,
    error: activityGroupsError,
    data,
  } = useQuery<OneviewGroups>(GET_ACTIVITY_GROUPS);

  useEffect(() => {
    if (!activityGroupsError) {
      return;
    }
    pullActGroup();
  }, [activityGroupsError]);

  const activityGroups = useMemo(
    () =>
      data?.oneviewGroups?.map((activityGroup) => {
        return {
          ...activityGroup,
          activitySubGroups:
            activityGroup.activitySubGroups?.filter(subActivityGroupFilter) || [],
        };
      }) || [],
    [data?.oneviewGroups]
  );

  const subActivityGroups = useMemo(
    () =>
      data?.oneviewGroups
        ?.map((a) => a.activitySubGroups!)
        ?.flat()
        .filter(subActivityGroupFilter) || [],
    [data?.oneviewGroups]
  );

  return {
    activityGroups,
    subActivityGroups,
    activityGroupsLoading,
    activityGroupsError,
  };
}
